import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	const slidesBlocks = document.querySelectorAll('.wp-block-embark-slides-landing-page .pin-spacer');

	// Smaller "top Npx" = pin/slide progression starts after more scroll (section top must reach a line closer to the viewport top).
	// Theme xl = 1380px — laptops/tablets often sat in the old ≥768 bucket with `top 180px`, which fired too early and clipped content.
	const getStartPosition = () => {
		const w = window.innerWidth;
		if (w < 768) return 'top 100px';
		if (w < 1380) return 'top 110px';
		return 'top 130px';
	};

	// Function to calculate slide height based on viewport.
	const calculateSlideHeight = (slide) => {
		const isMobile = window.innerWidth < 768;
		if (isMobile) {
			const originalWidth = slide.style.width;
			slide.style.width = '100%';
			const height = slide.scrollHeight;
			slide.style.width = originalWidth;
			return height;
		}
		return slide.offsetHeight;
	};

	slidesBlocks.forEach((block) => {
		const section = block.querySelector('section');
		const slides = block.querySelector('.slides-block__slides');
		const slidesContainer = block.querySelector('.slides-block__slidesContainer');
		const slideElements = block.querySelectorAll('.slides-block__slide');

		if (!section || !slides || !slidesContainer || !slideElements.length) return;

		slides.style.height = '';
		slides.style.minHeight = '';
		slideElements.forEach((slide) => {
			slide.style.minHeight = '';
			slide.style.position = 'relative';
		});

		let tallestSlideHeight = 0;
		slideElements.forEach((slide) => {
			const height = calculateSlideHeight(slide);
			if (height > tallestSlideHeight) tallestSlideHeight = height;
		});

		slides.style.height = `${tallestSlideHeight}px`;
		slides.style.overflow = 'hidden';

		slideElements.forEach((slide) => {
			slide.style.minHeight = `${tallestSlideHeight}px`;
		});

		const isMobile = window.innerWidth < 768;
		const scrollTrigger = ScrollTrigger.create({
			trigger: section,
			toggleActions: 'restart none none reverse',
			pin: true,
			start: getStartPosition(),
			end: isMobile ? '+=100%' : 'bottom top',
			ease: 'none',
			delay: 0.1,
			onUpdate: (self) => {
				const { progress } = self;
				const totalSlides = slideElements.length;
				const currentSlide = Math.min(Math.round(progress * (totalSlides - 1)), totalSlides - 1);
				const slideOffset = tallestSlideHeight * currentSlide;
				slidesContainer.style.transform = `translateY(-${slideOffset}px)`;
			},
		});

		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				// Recalculate heights
				tallestSlideHeight = 0;
				slideElements.forEach((slide) => {
					const height = calculateSlideHeight(slide);
					if (height > tallestSlideHeight) tallestSlideHeight = height;
				});

				slides.style.height = `${tallestSlideHeight}px`;
				slideElements.forEach((slide) => {
					slide.style.minHeight = `${tallestSlideHeight}px`;
				});

				scrollTrigger.vars.start = getStartPosition();
				scrollTrigger.vars.end = window.innerWidth < 768 ? '+=100%' : 'bottom top';
				scrollTrigger.refresh();
			}, 250);
		});

		const images = block.querySelectorAll('img');
		images.forEach((img) => {
			if (img.complete) {
				ScrollTrigger.refresh();
			} else {
				img.addEventListener('load', () => {
					ScrollTrigger.refresh(true);
				});
			}
		});
	});
});
